import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { jsonToQueryString } from '@/utils/http-utils';
import sortBy from 'lodash/sortBy';
import dayjs from 'dayjs';
import {
  removeAllEvents,
  setAllEvents,
  upsertManyEvents,
} from './billboardEvents.slice';
import { useLazyGetBillboardsEventsQuery } from '@/store/billboard/billboard.api';
import { formatUTCDate } from '@/locales/dates';
import { PAGE_SIZE } from './filters.slice';

export const sortArrayByDate = (data) => {
  const sortedData = sortBy(data, (item) => dayjs(item.date, 'YYYY-MM-DD'));
  return sortedData;
};

const sortArrayByStartDate = (data) => {
  const sortedData = sortBy(data, (item) => dayjs(item.start_date));
  return sortedData;
};

export const parseGroupedEvents = (data) => {
  return data.map((item) => {
    const firstEvent = item.event_information[0];
    const formatedDate = formatUTCDate(firstEvent.start_date, 'DD/MM/YYYY');
    return {
      ...firstEvent,
      name: item.name,
      date: item.date,
      formatedDate,
      dates: sortArrayByStartDate(item.event_information).map((event) => {
        return {
          hour: formatUTCDate(event.start_date, 'h:mm A'),
          subdomain: event.subdomain,
        };
      }),
    };
  });
};

export default function useBillboard(billboardId, isPaginated = false, about) {
  const dispatch = useDispatch();
  const [trigger] = useLazyGetBillboardsEventsQuery();
  const billboardFilters = useSelector((state) => state.billboardFilters);
  const billboardEvents = useSelector((state) =>
    state.billboardEvents.ids.map((id) => state.billboardEvents.entities[id]),
  );

  const [isMore, setMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);

  const loadEventsPage = async () => {
    setIsFetching(true);

    const queryParams = jsonToQueryString({
      ...(about ? { about } : {}),
      ...billboardFilters,
    });
    const { data: dataComplete } = await trigger(
      isPaginated
        ? `${billboardId}${queryParams ? queryParams : ''}`
        : billboardId,
    );

    if (
      dataComplete &&
      dataComplete.events_information &&
      dataComplete.events_information.length > 0
    ) {
      if (billboardFilters.offset === 0) {
        dispatch(removeAllEvents());
        dispatch(
          setAllEvents(
            sortArrayByDate(
              parseGroupedEvents(dataComplete.events_information),
            ),
          ),
        );
      } else {
        dispatch(
          upsertManyEvents(
            sortArrayByDate(
              parseGroupedEvents(dataComplete.events_information),
            ),
          ),
        );
      }
      if (isPaginated && billboardEvents?.length > PAGE_SIZE) {
        setMore(true);
      } else {
        setMore(false);
      }
    } else {
      setMore(false);
    }

    setIsFetching(false);
  };

  useEffect(() => {
    loadEventsPage().then();
  }, [billboardFilters]);

  return {
    billboardEvents,
    isMore,
    isFetching,
  };
}
